import ExpandableTable from '@dealroadshow/uikit/core/components/Table/ExpandableTable';
import { mapDealFields } from '@/finsight/ui/components/deals/DealListTable/helpers';
import cloneDeep from 'lodash/cloneDeep';

export interface IGenericTableProps<T> {
  columns: any[],
  collection: T[],
  expandableRowContent?: React.ComponentType<any>,
  isFetching?: boolean,
  expandableComponent?: React.ReactNode,
  className?: string,
  dataTest?: string,
  isRowsExpanded?: boolean,
  defaultExpandedRowIndexes?: number[],
  expandCollapseOnRowClick?: boolean,
  onRowClick?: (
    e: React.MouseEvent<HTMLTableRowElement>,
    params: { row: Record<string, any>, index: number, isExpanded: boolean },
  ) => void,
  RowWrapper?: React.ComponentType<any>,
}

export const GenericTable = <T extends any>({
  columns,
  collection,
  expandableRowContent,
  isFetching = false,
  expandableComponent,
  onRowClick,
  RowWrapper,
  className,
  dataTest = 'genericTable',
  isRowsExpanded = false,
  defaultExpandedRowIndexes = [],
  expandCollapseOnRowClick = true,
}: IGenericTableProps<T>) => {
  const mappedCollection = collection.map((item, index) => mapDealFields(cloneDeep(item), index, collection.length));

  return (
    <>
      <ExpandableTable
        className={ className }
        columns={ columns }
        collection={ mappedCollection }
        isRowsExpanded={ isRowsExpanded }
        isFetching={ isFetching }
        dataTest={ dataTest }
        expandableRowContent={ expandableRowContent }
        defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
        expandCollapseOnRowClick={ expandCollapseOnRowClick }
        onRowClick={ onRowClick }
        RowWrapper={ RowWrapper }
      />
      { expandableComponent }
    </>
  );
};
